import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
    minHeight: 180,
    padding: 8,
    borderRadius: 16,
    overflow: 'hidden',
    // marginBottom: 16,
  },
  title: {
    textAlign: 'center',
    textTransform: 'uppercase',
    marginBottom: 8,
    fontWeight: 700,
    fontSize: 18,
    textOverflow: 'ellipsis',
  },
  buttonsContainer: {
    maxWidth: '80%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 32,
    alignSelf: 'center',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.text.hint,
  },
  button: {
    height: 24,
    width: 96,
    backgroundColor: theme.palette.background.paper,
  },
  buttonText: {
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  loadingContainer: {
    minHeight: 160,
    position: 'relative',
    top: 35,
  },
}));
